import { render, staticRenderFns } from "./WelcomeBlock.vue?vue&type=template&id=fdb2f564&"
import script from "./WelcomeBlock.vue?vue&type=script&lang=ts&"
export * from "./WelcomeBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports